import { create } from "zustand";

/**
 * useDistribuicaoEpiListaFilters
 */

type State = {
  idsGestaoEpi: number[] | null;
  idsFuncionarios: number[] | null;
  ca: string | null;
  dataEntrega: (Date | null)[] | null;
};

export const initialDistribuicaoEpiListaState = {
  idsGestaoEpi: null,
  idsFuncionarios: null,
  ca: null,
  dataEntrega: null,
};

export const useDistribuicaoEpiListaFilters = create<State>((set, get) => ({
  ...initialDistribuicaoEpiListaState,
}));